module.exports = __webpack_public_path__ + "img/instagram.5382f351.jpg";